import type { ServicesManager } from '@wix/services-manager/types'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { SiteServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import type { IMultilingualService } from '@wix/viewer-service-multilingual/definition'
import { MultilingualDefinition } from '@wix/viewer-service-multilingual/definition'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { toMultilingualServiceConfig } from '../config'
import { name } from '../symbols'
import type { MultilingualServiceEditorHandlers } from '../types'

export const multilingualServiceSideEffectsFactory = (
	servicesManager: ServicesManager
): IModelUpdatesHandlersImplementor<MultilingualServiceEditorHandlers> => ({
	featureName: name,
	handlers: {
		updateMultilingualServiceConfig(localesInfo) {
			if (servicesManager.hasService(MultilingualDefinition)) {
				const multilingualService = servicesManager.getService(MultilingualDefinition) as IMultilingualService
				multilingualService._updateConfig(toMultilingualServiceConfig(localesInfo))
			}
		},
	},
})

export const MultilingualServiceSideEffects = withDependencies(
	[SiteServicesManagerSymbol],
	multilingualServiceSideEffectsFactory
)
